export default "__VITE_ASSET__CicUWyPP__"